export default __webpack_public_path__ + "static/report-image-two-749a5616a7059dbd00536dc1be237ec2.png";